/**
 * This is the main entry point of the Javascript.
 * It initializes the necessary components.
 */

// import { setCookie, getCookie } from "./components/cookies";
import Links from "./components/Links";
import Sliders from "./components/Sliders";

document.addEventListener("DOMContentLoaded", () => {
	// console.log("first run");

    Sliders();
    Links();

    const headerMain = document.querySelector('.header__main-wrapper');
    const burgerJs = document.querySelector('.burger-js');
    const burgerWrapper = document.querySelector('.burger-menu');
    const closeBurger = document.querySelector('.burger-menu__wrapper-left-close');

    if(burgerJs) {
        burgerJs.addEventListener('click', function() {

            if(burgerWrapper) {
                burgerWrapper.classList.add('active');
            }

        })
    }

    if(closeBurger) {
        closeBurger.addEventListener('click', function() {
            if(burgerWrapper) {
                burgerWrapper.classList.remove('active');
            }
        })
    }

    if (headerMain) {

        const stickyOffset = 600;
        let headerMainHeight = 0;

        const setSizes = () => {
            if (!headerMain.classList.contains('is-fixed')) {
                headerMainHeight = headerMain.offsetHeight;
            }
        };

        const onScroll = () => {

            if (window.scrollY > stickyOffset) {

                document.body.style.paddingTop = `${headerMainHeight}px`;

                if (!headerMain.classList.contains('is-fixed')) {
                    headerMain.classList.add('is-fixed');

                    setTimeout(() => {
                        headerMain.classList.add('is-visible');
                    }, 20);
                }

            } else {

                headerMain.classList.remove('is-fixed', 'is-visible');
                document.body.style.paddingTop = '';

            }

        };

        setSizes();
        onScroll();

        window.onscroll = onScroll;

        window.onresize = () => {
            setSizes();
            onScroll();
        };

    }
});
